'use strict';

import { GA, EMARSYS } from "../constants/ActionTypes";

const initialGAState = {
    GA_DATA: null,
    GA_EVENT_NAME: 'empty',
    GA_DATA_EVENT: null,
    USER: false,

    emarsysParamsQueue: [],
    SAVE_DATA_STATUS: false
};

export default function (state = initialGAState, action = {}) {
    switch (action.type) {
        case GA.GA_DATA:
            return Object.assign({}, state, {
                [action.GA_EVENT_NAME]: action.GA_DATA_CONTENT
            });
        case GA.GA_DATA_PAGE:
            return Object.assign({}, state, {
                GA_DATA_EVENT: action.GA_DATA_CONTENT_PAGE
            });
        case GA.USER:
            return Object.assign({}, state, {
                USER: action.USER
            });
        case EMARSYS.SAVE_DATA_STATUS:
            return Object.assign({}, state, {
                SAVE_DATA_STATUS: action.SAVE_DATA_STATUS,
            });
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./common/reducers/dataGA.js